<template lang="html">
  <div class="">
    <Random />
    <Rule />
    <Andalinpoint />
    <AlibabaPayment />
    <FormBooking />
    <Payment />
    <Survey />
    <RateUs />
    <FormAddress />
    <OptionModal />
    <ResultActionModal />
    <ConfirmModal />
    <DocumentModal/>
    <VesselSchedule />
    <DuplicateLand />
    <DuplicateAir />
    <DuplicateOcean />
    <!-- <CreateShipment /> -->
  </div>
</template>

<script>
import Random from '@/components/global/modals/Random.vue'
import Rule from '@/components/global/modals/Rule.vue'
import Andalinpoint from '@/components/global/modals/Andalinpoint.vue'
import AlibabaPayment from '@/components/global/modals/AlibabaPayment.vue'
import FormBooking from '@/components/global/modals/FormBooking.vue'
import Payment from '@/components/global/modals/Payment.vue'
import Survey from '@/components/global/modals/Survey.vue'
import RateUs from '@/components/global/modals/RateUs.vue'
import FormAddress from '@/components/global/modals/AddressForm.vue'
// import CreateShipment from '@/components/global/modals/CreateShipment.vue'
import OptionModal from '@/components/global/modals/OptionModal.vue'
import ResultActionModal from '@/components/global/modals/ResultActionModal.vue'
import ConfirmModal from '@/components/global/modals/ConfirmModal'
import DocumentModal from '@/components/global/modals/DocumentModal.vue'
import VesselSchedule from '@/components/global/modals/VesselSchedule.vue'
import DuplicateLand from '@/components/requestShipment/newRequestShipment/FormShipmentLand.vue'
import DuplicateAir from '@/components/requestShipment/newRequestShipment/FormShipmentAir.vue'
import DuplicateOcean from '@/components/requestShipment/newRequestShipment/FormShipmentOcean.vue'

export default {
  components: {
    Random,
    Rule,
    Andalinpoint,
    AlibabaPayment,
    FormBooking,
    Payment,
    Survey,
    RateUs,
    FormAddress,
    OptionModal,
    ResultActionModal,
    ConfirmModal,
    // CreateShipment
    DocumentModal,
    VesselSchedule,
    DuplicateLand,
    DuplicateAir,
    DuplicateOcean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/Main.vue